class MyAccount  {
	constructor() {
		this.init();
	}
	init() {
		this.setEvents();
	}

	setEvents() {
		$('a.filter-trigger').on('click', () => $('div.filters-wrapper').addClass('fixed'));
		$('div.filters-wrapper a.close').on('click', () => $('div.filters-wrapper').removeClass('fixed'));
		$('.myaccount').on('click','div.my-account-orders-table tr.cursor-pointer > td:not(.checkbox)', this.showOrderDetail.bind(this));
		$('#search-routes').on('click', this.searchOrders.bind(this));
		$('.concept-copy').on('click', this.copyConcept.bind(this));
	}

	searchOrders(event) {
		let searchTerm = $(event.target).parent().find('input[type="text"]').val();
		$('#routes').find('table tr').each(function(it, tr){
			if ($(tr).html().indexOf(searchTerm) != -1) {
				$(tr).parent().children().hide();
				$(tr).show();
				$(tr).parents('.collapse').collapse('show');
			} else {
				$(tr).parents('.collapse').collapse('hide');
			}
		});
	}

	showOrderDetail(event) {
		if($(event.target).parent().is('A')) {
			if ($(event.target).parent().attr('href') != '#') {
				return true;
			}
		}

		let tr = $(event.currentTarget).parent();
		// first close all
		$(tr).parent().find('tr.cursor-pointer:not("#'+$(tr).attr('id')+'")').each(function(it, el) {
			$(el).find('a.more').removeClass('active');
			$(el).next().removeClass('show');
		});
		let target = $(tr).find('a.more');
		if($(target).hasClass('has-data')) {
			$(target).parents('tr:first').next().toggleClass('show');
			$(target).toggleClass('active');
			return false;
		}
		window.showLoader();
		jQuery.get('?action=get-order-info&id=' + $(target).data('id'), function (data) {
			$(target).parents('tr:first').next().find('td').html(data.html);
			$(target).parents('tr:first').next().toggleClass('show');
			$(target).toggleClass('active');
			if(!$(target).hasClass('has-data')) {
				$(target).addClass('has-data');
			}
			window.hideLoader();
			return false;
		}, 'json');
		return false;
	}

	copyConcept(e) {
		$(e.currentTarget).closest('form').submit();
	}
}

export default MyAccount;